"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.snakeToCamelConverter = void 0;
var snakeToCamelConverter = function (string) {
    return string.replace(/_./g, function (x) { return x.toUpperCase()[1]; });
};
exports.snakeToCamelConverter = snakeToCamelConverter;
//# sourceMappingURL=snakeToCamel.js.map